import {Link} from "@/shared/ui/Link";
import {ucFirst} from "@/shared/lib/string/ucFirst";
import {CatalogTag} from "@/widgets/catalog-tags";
import styles from "./CatalogTags.module.scss";

type Props = {
    tags: CatalogTag[];
};

export const CatalogTags = ({tags}: Props) => {
    if (!tags.length) return null;

    return (
        <div className={styles.tags}>
            <div className={styles.title}>С этими товарами ищут</div>
            <div className={styles.list}>
                {tags.map((tag) => (
                    <Link key={tag.href} href={tag.href} className={styles.item}>
                        {ucFirst(tag.value)}
                    </Link>
                ))}
            </div>
        </div>
    );
};
